export const GET_DETAILS_REQUEST = "GET_DETAILS_REQUEST";
export const GET_DETAILS_SUCCESS = "GET_DETAILS_SUCCESS";
export const GET_DETAILS_FAILURE = "GET_DETAILS_FAILURE";

export const ADD_DETAILS_REQUEST = "ADD_DETAILS_REQUEST";
export const ADD_DETAILS_SUCCESS = "ADD_DETAILS_SUCCESS";
export const ADD_DETAILS_FAILURE = "ADD_DETAILS_FAILURE";

export const EDIT_DETAILS_REQUEST = "EDIT_DETAILS_REQUEST";
export const EDIT_DETAILS_SUCCESS = "EDIT_DETAILS_SUCCESS";
export const EDIT_DETAILS_FAILURE = "EDIT_DETAILS_FAILURE";

export const PATCH_DETAILS_REQUEST = "PATCH_DETAILS_REQUEST";
export const PATCH_DETAILS_SUCCESS = "PATCH_DETAILS_SUCCESS";
export const PATCH_DETAILS_FAILURE = "PATCH_DETAILS_FAILURE";

export const DELETE_DETAILS_REQUEST = "DELETE_DETAILS_REQUEST";
export const DELETE_DETAILS_SUCCESS = "DELETE_DETAILS_SUCCESS";
export const DELETE_DETAILS_FAILURE = "DELETE_DETAILS_FAILURE";

export const GET_APPLY_DATA_REQUEST = "GET_APPLY_DATA_REQUEST";
export const GET_APPLY_DATA_SUCCESS = "GET_APPLY_DATA_SUCCESS";
export const GET_APPLY_DATA_FAILURE = "GET_APPLY_DATA_FAILURE";

export const SEARCH_DATA_REQUEST = "SEARCH_DATA_REQUEST";
export const SEARCH_DATA_SUCCESS = "SEARCH_DATA_SUCCESS";
export const SEARCH_DATA_FAILURE = "SEARCH_DATA_FAILURE";

export const GET_CART_DATA_REQUEST = "GET_CART_DATA_REQUEST";
export const GET_CART_DATA_SUCCESS = "GET_CART_DATA_SUCCESS";
export const GET_CART_DATA_FAILURE = "GET_CART_DATA_FAILURE";

export const GET_COURSE_DATA_REQUEST = "GET_COURSE_DATA_REQUEST";
export const GET_COURSE_DATA_SUCCESS = "GET_COURSE_DATA_SUCCESS";
export const GET_COURSE_DATA_FAILURE = "GET_COURSE_DATA_FAILURE";

export const POST_ADDTOCART_REQUEST = "POST_ADDTOCART_REQUEST";
export const POST_ADDTOCART_SUCCESS = "POST_ADDTOCART_SUCCESS";
export const POST_ADDTOCART_FAILURE = "POST_ADDTOCART_FAILURE";

export const DELETE_CART_REQUEST = "DELETE_CART_REQUEST";
export const DELETE_CART_SUCCESS = "DELETE_CART_SUCCESS";
export const DELETE_CART_FAILURE = "DELETE_CART_FAILURE";
